import {
	preventDoubleClick
} from '../global/_doubleClick';

export function mobileZoomIframe(params, returnHTML) {
      function myCallback() {
          params.mainImg;
          preventDoubleClick();
      };
      var img = $(".mainImage");
      var imgSrc = $(".mainImage").attr('src');
      var html = '<div class="pinch-zoom"><img src="' + imgSrc + '" alt="Main Product Image"/></div>';
      returnHTML(html, myCallback);
      return false;
  };
